var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLocal = function SvgLocal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FAD248",
    d: "M1 20C1 9.507 9.507 1 20 1s19 8.507 19 19-8.507 19-19 19S1 30.493 1 20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#773610",
    strokeWidth: 2,
    d: "M1 20C1 9.507 9.507 1 20 1s19 8.507 19 19-8.507 19-19 19S1 30.493 1 20Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#773610",
    strokeMiterlimit: 10,
    d: "M26.06 30V10.606h-.606a2.424 2.424 0 0 0-2.424 2.424v9.091h3.03M13.939 10v5.77c0 1.442 1.084 2.612 2.424 2.612s2.424-1.17 2.424-2.612V10m-2.424 20V10"
  })));
};
export default SvgLocal;